import { render, staticRenderFns } from "./EventProgramTable.vue?vue&type=template&id=6a852c82"
import script from "./EventProgramTable.vue?vue&type=script&lang=js"
export * from "./EventProgramTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports